// store.js
import { reactive } from 'vue';

export const globalStore = reactive({
  props: null
});

